<template>
  <div class="info-box static">
    <div class="flex-1 overflow-y-auto gap-x-3">
      <el-form
        :model="state.model"
        label-width="auto"
        label-position="top"
        ref="formDom"
        size="large"
        class="px-2.5"
      >
        <ul class="grid gap-x-5" style="grid-template-columns: 1fr 100px">
          <el-form-item
            label="宴会厅名称"
            prop="name"
            :rules="[
              { required: true, message: '请输入宴会厅名称', trigger: 'blur' },
            ]"
          >
            <el-input v-model="state.model.name"></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-switch
              v-model="state.model.status"
              active-text="启用"
              inactive-text="禁用"
              inline-prompt
              :active-value="1"
              :inactive-value="0"
            />
          </el-form-item>
        </ul>
        <ul class="grid grid-cols-4 gap-x-3">
          <el-form-item label="楼层">
            <el-input-number
              v-model="state.model.floor"
              @focus="$onFocus"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="长度">
            <el-input-number
              v-model="state.model.hall_length"
              class="number-input-left number-input-suffix"
              suffix="m"
              @focus="$onFocus"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="宽度">
            <el-input-number
              v-model="state.model.hall_width"
              class="number-input-left number-input-suffix"
              suffix="m"
              @focus="$onFocus"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="高度">
            <el-input-number
              v-model="state.model.hall_height"
              class="number-input-left number-input-suffix"
              suffix="m"
              @focus="$onFocus"
            ></el-input-number>
          </el-form-item>
        </ul>
        <el-form-item label="说明">
          <el-input
            v-model="state.model.intro"
            type="textarea"
            :autosize="{ minRows: 3 }"
          ></el-input>
        </el-form-item>
        <el-form-item label="附件">
          <c_UploadFile
            :key="state.model.id"
            :value="state.model.files"
            @change="
              (data) => {
                state.model.files = data;
              }
            "
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="submit-box px-2.5">
      <el-button type="primary" @click="onSubmit"> 提交 </el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  hotel_hall_detail,
  hotel_hall_add,
  hotel_hall_edit,
} from "@/http/hotel";
import { post_response } from "@/utils/funcs";

export default {
  props: {
    id: Number,
    hotel_id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: { hotel_id: props.hotel_id, status: 1, files: [] },
    });
    onMounted(() => {
      if (props.id) {
        hotel_hall_detail(props.id).then((res) => {
          if (res.status == 200) {
            const data = res.data?.data;
            state.model = data;
            state.model.files = data.attachment_img;
          }
        });
      }
    });

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          state.model.attachment_img = JSON.stringify(
            state.model.files?.map((m) => m.id),
          );
          if (props.id) {
            hotel_hall_edit(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          } else {
            hotel_hall_add(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          }
        }
      });
    };

    return {
      state,
      props,
      formDom,
      onSubmit,
    };
  },
};
</script>
<style scoped></style>
